var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1851 2.95331C13.3498 2.88397 13.5302 2.86006 13.7073 2.88405C13.8844 2.90805 14.0519 2.97909 14.1922 3.08977C14.3326 3.20044 14.4407 3.34672 14.5053 3.51337C14.57 3.68001 14.5888 3.86094 14.5598 4.03731L13.0478 13.2086C12.9011 14.0933 11.9304 14.6006 11.1191 14.16C10.4404 13.7913 9.43242 13.2233 8.52575 12.6306C8.07242 12.334 6.68375 11.384 6.85442 10.708C7.00109 10.13 9.33442 7.95798 10.6678 6.66664C11.1911 6.15931 10.9524 5.86664 10.3344 6.33331C8.79975 7.49198 6.33575 9.25398 5.52109 9.74998C4.80242 10.1873 4.42775 10.262 3.97975 10.1873C3.16242 10.0513 2.40442 9.84064 1.78575 9.58398C0.949753 9.23731 0.99042 8.08798 1.78509 7.75331L13.1851 2.95331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperplane);
export default __webpack_public_path__ + "static/media/paperplane.a38116379abc36fe6318b657a76bfc38.svg";
export { ForwardRef as ReactComponent };